var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('img',{attrs:{"src":"/tick.jpg"}}):(!_vm.hideCross)?_c('img',{attrs:{"src":"/cross.jpg"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }